import React from 'react';
import { formatPrice } from '../functions/PriceRangeApi';

export const PriceInput = ({ label, value, onChange, min = 0, max = 10000 }) => {
  const handleChange = (e) => {
    const inputValue = e.target.value.replace(/,/g, ''); // Remove commas for parsing
    const newValue = parseInt(inputValue) || min;
    const clampedValue = Math.max(min, Math.min(max, newValue));
    onChange(clampedValue);
  };

  const handleBlur = (e) => {
    const inputValue = e.target.value.replace(/,/g, '');
    const newValue = parseInt(inputValue) || min;
    const clampedValue = Math.max(min, Math.min(max, newValue));
    onChange(clampedValue);
  };

  return (
    <div className="w-full space-y-[8px] sm:space-y-[10px]">
      <div className="font-semibold text-[12px] sm:text-sm">{label}</div>
      <div className="flex gap-2 bg-white px-[10px] sm:px-[12px] w-full py-[6px] sm:py-[8px] border-[2px] border-[#E3E3E3] rounded-[10px] sm:rounded-[12px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
        <div className="text-[12px] sm:text-sm">USDC</div>
        <input
          className="outline-none w-full text-[12px] sm:text-sm filter-input-mobile"
          type="text"
          min={min}
          max={max}
          value={formatPrice(value)}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
};